import * as React from "react";

function SvgTipTruck(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M10.328 11.2517C11.0587 11.2517 11.651 10.6594 11.651 9.92876C11.651 9.1981 11.0587 8.60578 10.328 8.60578C9.59736 8.60578 9.00504 9.1981 9.00504 9.92876C9.00504 10.6594 9.59736 11.2517 10.328 11.2517Z"
          fill={fill ?? "black"}
        />
        <path
          d="M12.4934 5.75386C12.3138 5.39209 11.8358 5.09634 11.4318 5.09634H9.96096V8.07501C10.0798 8.05124 10.2039 8.03804 10.328 8.03804C11.342 8.03804 12.1659 8.86193 12.1659 9.87594C12.5726 9.87594 12.9 9.54586 12.9 9.14184V8.03804V6.56719L12.4934 5.75386ZM12.3772 6.93424H10.6951V5.46339H11.4292C11.6325 5.46339 11.8702 5.61127 11.9599 5.79347L12.3745 6.62528L12.3772 6.93424Z"
          fill={fill ?? "black"}
        />
        <path
          d="M4.39708 11.2517C5.12774 11.2517 5.72005 10.6594 5.72005 9.92876C5.72005 9.1981 5.12774 8.60578 4.39708 8.60578C3.66642 8.60578 3.0741 9.1981 3.0741 9.92876C3.0741 10.6594 3.66642 11.2517 4.39708 11.2517Z"
          fill={fill ?? "black"}
        />
        <path
          d="M8.46635 7.64194L6.47792 5.08577L7.63982 3.93708L5.89962 2.19688L5.83888 2.13615L5.64083 1.9381L5.44278 1.74005L5.59594 1.58689C5.73062 1.45221 5.73062 1.23568 5.59594 1.10101C5.46127 0.966332 5.24473 0.966332 5.11006 1.10101L4.46838 1.74269L-0.0999756 6.25823L2.58558 7.64194H2.51164V7.66834C2.51164 8.07501 2.84173 8.40245 3.24575 8.40245H3.29328V8.41301C3.60224 8.18063 3.97985 8.0354 4.39708 8.0354C5.4111 8.0354 6.23498 8.85928 6.23498 9.8733H8.49011C8.49011 9.12071 8.94431 8.47639 9.59391 8.19119V7.64194H8.46635ZM3.89271 7.64194L5.98412 5.57165L7.59493 7.64194H3.89271Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgTipTruck;
